import script from "./StaffScheduleMenuBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./StaffScheduleMenuBlock.vue?vue&type=script&setup=true&lang=js"

import "./StaffScheduleMenuBlock.vue?vue&type=style&index=0&id=339df166&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-339df166"]])

export default __exports__